import { EmailAccountConnectorPrivacyLevelEnum } from '../../../../api/emailAccountConnector/enums/email-account-connector-privacy-level.enum';
import { EmailAccountConnectorApi } from '../../../../api/emailAccountConnector/models/email-account-connector.api';
import { DataConnectorTypesEnum } from '../../../../api/externalData/enums/data-connector-types.enum';
import { DataConnectorModel } from '../../../../Core/Users/models/data-connector.model';

export class DataConnectionCardModel {
    type: DataConnectorTypesEnum;
    createdDate?: Date;
    name?: string;
    email?: string;
    privacyLevel?: EmailAccountConnectorPrivacyLevelEnum;
    emailAccountConnector?: EmailAccountConnectorApi;
    dataConnector?: DataConnectorModel;
    icon?: string;
    loading?: boolean = false;

    constructor(connector?: EmailAccountConnectorApi | DataConnectorModel) {
        if (connector) {
            this.createdDate = connector.createdDate;

            if (connector instanceof DataConnectorModel) {
                this.type = connector.type;
                this.name = connector.name;
                this.dataConnector = connector;
            } else {
                // Only Email account connector for now
                this.type = DataConnectorTypesEnum.EMAIL_ACCOUNT;
                this.icon = 'fa-regular fa-duotone fa-envelope';
                this.name = connector.connectorName;
                this.email = connector.connectorEmail;
                this.privacyLevel = connector.privacyLevel;
                this.emailAccountConnector = connector;
            }
        }
    }
}
